var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicalExaminationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8423",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8423",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADCUlEQVR4nO3dP27UQBgF8DcrSMMf0bJJS4eQgCriCpG4QEoUCYXjIIGEqKAIRSooOAGJBJsCEFegiCg2CU1SPAo7yBpvtF7vjudZfr8u1trzzbx47ZlYMWBmZmZmZmZmVkNyjeQLkockz5jeGckDkrsk13L3XwrJMcmjDkK4yoTk3dzjAAAhdwHlb+chgIeZS5kA2AwhXOQsYpSz8dIO8ocBAI8BPMtdRHYsrhlVH0mud9DuetlW1ZfU7cojeRoNSvIwKm1vRG2fdNX2VRSuIaz+HELotKbc7ccUriFW4UDEOBAxDkSMAxHz/46inDHvANgGcB/AjVxFDcRfAD8AvAfwJoRwDpSBkBwD+ASNGfMQHQHYCiH8DkJrSUM3AbA5gs5a0tAVa2m51pKG7sq1tJxrSUM3ay0tqK3lDE08/p6HiHEgYhyIGAcixoGIaRUIyXsk90mecL4Tkh/6fDvdaX/jozUs7k+DwmLHfQwldX9r41/bMP8A+y2Ku7S3mmHqTur+xjssPDFk8WTGrZb9m4YQ7rTcN4vU/a2Nf7xhUQ0CXOr4alL3N+ldFkWel+3KKvqb+rb3PPHx1SzdX39lLSh1f9tc1KcAbrdsr48X9aT9jce/zVfW5xb7rGLfXLrtb3wf3ODz6ywmPYs6ZvEwRa+k7m9t/GsbmhU5JrlHctqgsGn52d6FcSllf+Od/RfDzOLx92qvGAcixoGIuZa7gLbm3YD09VroM0SMAxHjQMQ4EDEORIwDEeNAxMjOQ5oudLbdX3We4jNEjAMR40DEOBAxDkSMAxHjQMTIzkOWfSBNdZ4xj88QMQ5EjAMR40DEOBAxDkSMAxEjOw+Zp6/zjHl8hohxIGIciBgHIsaBiHEgYhyIGAcixoGIGQE4rW4guZGplsGZMdanIwC/oo2v2MP//NY3ZRivo80/A8ldAC8z1GR1zy9fV3EA4FHuagbuK4Ano/LNLlso3l9heXwD8DSEcFF95dF1FO+C3QbwAMDNTMUNxRmA7wDeAXib+6XIZmZmZmZmZjbLPzEEIuyOWSRcAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalExaminationIcon);
export default __webpack_public_path__ + "static/media/MedicalExaminationIcon.892b7d6f224481728c7fba2622a819bc.svg";
export { ForwardRef as ReactComponent };